import { LEGEND_MODE } from "constants/navigation";
import { PlanDimension, WarehouseInfos } from "models/PlanInfos";
import { RootState } from "store/store";

export const getWarehousePlan = (state: RootState): WarehouseInfos =>
  state.warehousePlanSlice.warehousePlan;

export const getWarehousePlanDimensions = (
  state: RootState
): PlanDimension | undefined =>
  state.warehousePlanSlice.warehousePlan.plan?.dimensions;

export const getIsGridRendered = (state: RootState): boolean =>
  state.warehousePlanSlice.isGridRendered;

export const getLegendDisplayMode = (state: RootState): LEGEND_MODE =>
  state.warehousePlanSlice.legendDisplayType;
